export default function Input({ className = '', ...props }) {
    return (
        <input
            className={`w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
            {...props}
        />
    );
}
